import Portfolio10 from './Portfolio10'
export default Portfolio10
